<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">SECTION E: STUDENT'S RIGHT TO CANCEL (WITHDRAWAL) AND REFUND POLICY</p>
                    </div>
                    <div>
                        <p>
                            If a student elects to cancel their registration or withdraw from the TEFL certificate
                            program, the following strict timeline replaces standard semester schedules:
                        </p>
                    </div>
                </b-col>

                <!-- Refund Table -->
                <b-col cols="12">
                    <b-table-simple bordered responsive class="text-sm text-md-md">
                        <b-thead>
                            <b-tr>
                                <b-th>Written Request Submission Timeline</b-th>
                                <b-th>Refund Percentage Allowed</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td class="font-weight-bold">At least seven (7) business days before the course start date</b-td>
                                <b-td>
                                    If a student withdraws from a class before classes begin, the student will be liable for an
                                    Administrative Cancellation Fee of $150.00 and the balance of the tuition will be refunded.
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="font-weight-bold">Within the 1st week of the program (prior to Friday deadline)</b-td>
                                <b-td>
                                    If a student withdraws during the first week of scheduled classes, the student will be charged an
                                    Administrative Cancellation Fee of $150 and 25% of the tuition.
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="font-weight-bold">After the conclusion of the 1st week of the program (after 5:00pm EST)</b-td>
                                <b-td>
                                    No Refund. All tuition and fees are non-refundable after the first week of scheduled classes
                                    (last business day of the first week by 5:00 pm EST).
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>

                <b-col cols="12" class="mt-2">
                    <ul>
                        <li>
                            <strong>Exclusions:</strong> Refunds exclude all registration fees, deposits, and mandatory
                            administrative charges, which remain strictly non-refundable.
                        </li>
                        <li>
                            <strong>Refund Request Deadline:</strong> All refund requests must be submitted within three
                            (3) business days following your official programmatic withdrawal date.
                        </li>
                        <li>
                            <strong>Official Process:</strong> Requests for withdrawal must be initiated formally on MyBAU
                            or submitted directly in writing to the Mentora College Administrative team. No refunds will be
                            honored or calculated without an official submission date tracked through MyBAU or the
                            administrative office.
                        </li>
                    </ul>
                </b-col>

                <!-- Checkbox + Button -->
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-tefl-e"
                                        v-model="form.status"
                                        name="checkbox-tefl-e"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>
                                    <div>
                                        I read and confirm that I understand the information in Section E.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {},
        }
    },
    created() {
        window.scrollTo(0, 0)
    },
    methods: {
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
